module.exports = __webpack_public_path__ + "img/15.14cc84eb.jpg";